import { createFileRoute } from "@tanstack/react-router";
import Cookies from "@/pages/legal/Cookies";

export const Route = createFileRoute("/cookie-policy")({
  component: Cookies,
});
